import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import moment from 'moment';
import {
    activate,
    deactivate,
    productMakeAutoUp,
    productMakeColored,
    productMakeUrgent,
    productMakeVip
} from "../../../api/product";
import { deleteAd } from "../../../api/user";
import { setProductDetails } from "../../../redux/actions/product_actions";
import '../../../dist/css/custom_card.css';
import editCircle from '../../../dist/icons/edit-circle.svg';
import deleteCircle from '../../../dist/icons/delete-circle.svg';
import { maxSymbolEllipsis } from "../../../helpers/functions";
import ProductItem from "./product_item";
import classNames from "classnames";
import { useEffectOnce } from "react-use";
import { useUserStore } from "../../../store/user_store";

// Simple toast state (module-level for simplicity)
let toastTimeout = null;

const UserProductItem = ({ product }) => {
    const dispatch = useDispatch();
    const { productsPlans } = useSelector((state) => state.plans);
    const user = useUserStore().user;

    // modal
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [subPlans, setSubPlans] = useState();
    const [plan, setPlan] = useState(null);
    const [modalImage, setModalImage] = useState();
    const [productId, setProductId] = useState();
    const [interval, setInterval] = useState(null);
    const [periodId, setPeriodId] = useState();
    const [period, setPeriod] = useState(0);
    const [itemPrice, setItemPrice] = useState(0);
    const [color, setColor] = useState(null);
    const [toast, setToast] = useState({ visible: false, message: '', type: 'success' });
    const history = useNavigate();

    const showToast = (message, type = 'success') => {
        setToast({ visible: true, message, type });
        clearTimeout(toastTimeout);
        toastTimeout = setTimeout(() => setToast({ visible: false, message: '', type: 'success' }), 3000);
    };

    const subscriptionPlans = async () => {
        const plans = productsPlans;
        if (plans != null) {
            setSubPlans(plans);
        }
    }

    const baseStyle = { height: 'auto' };
    if (typeof product.features === 'object' && !Array.isArray(product.features)) {
        if (product.features.color !== null) {
            baseStyle.backgroundColor = product.features.color;
        }
    }

    const removeAd = async () => {
        deleteAd(product.id);
        showToast('Успешно удалено!', 'success');
        setTimeout(() => { window.location.href = "/profile"; }, 1000);
    }

    const deactivateAd = async () => {
        deactivate(product.id);
        showToast('Успешно деактивировано!', 'success');
        setTimeout(() => { window.location.href = "/profile"; }, 1000);
    }

    const activateAd = async () => {
        activate(product.id);
        showToast('Успешно активировано!', 'success');
        setTimeout(() => { window.location.href = "/profile"; }, 1000);
    }

    //subscriptions
    const makeSubscriptionModal = async (id, name) => {
        var index = subPlans.findIndex(obj => obj.name == name);
        setPlan(subPlans[index]);
        setProductId(id);
        if (plan != null) {
            if (plan.interval == 'day') {
                setInterval("день");
            } else if (plan.interval == 'week') {
                setInterval("неделя");
            } else if (plan.interval == 'month') {
                setInterval('месяц');
            }
            setIsModalVisible(true);
        }
    }

    const buyServiceBySelectedPeriod = async (balance) => {
        if (balance > itemPrice) {
            const params = { 'period_id': periodId };
            const vip = await productMakeVip(productId, params);
            if (vip != null) {
                showToast("Успешно подключили услугу!", 'success');
                setIsModalVisible(false);
            } else {
                showToast("Услуга уже подключена!", 'warning');
                setIsModalVisible(false);
            }
        } else {
            showToast("Недостаточно средств!", 'error');
        }
    };

    const buyService = async (balance, planName) => {
        const params = { 'period': period };

        const serviceMap = {
            vip: productMakeVip,
            urgent: productMakeUrgent,
            make_auto: productMakeAutoUp,
        };

        if (planName === "colored") {
            if (balance <= itemPrice) {
                showToast("Недостаточно средств!", 'error');
                return;
            }
            if (!color) {
                showToast("Не выбрали цвет!", 'error');
                return;
            }
            const result = await productMakeColored(productId, { ...params, color });
            if (result != null) {
                showToast("Успешно подключили услугу!", 'success');
                setIsModalVisible(false);
            } else {
                showToast("Услуга уже подключена!", 'warning');
                setIsModalVisible(false);
            }
            return;
        }

        const serviceFn = serviceMap[planName];
        if (!serviceFn) return;

        if (balance > itemPrice) {
            const result = await serviceFn(productId, params);
            if (result != null) {
                showToast("Успешно подключили услугу!", 'success');
                setIsModalVisible(false);
            } else {
                showToast("Услуга уже подключена!", 'warning');
                setIsModalVisible(false);
            }
        } else {
            showToast("Недостаточно средств!", 'error');
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    var time = moment(product.created_at, 'YYYYMMDD, h:mm:ss a');
    moment.locale('ru');
    var update = time.fromNow();
    const image = product.media?.length > 0
        ? product.media[0].original_url
        : '';

    useEffectOnce(() => {
        subscriptionPlans();
    })

    const byStatus = ({
        active = () => { },
        inactive = () => { },
        moderation = () => { },
        disabled = () => { },
        orElse = () => { }
    }) => {
        switch (product.status) {
            case 'active': return active();
            case 'inactive': return inactive();
            case 'moderation': return moderation();
            case 'disabled': return disabled();
            default: return orElse();
        }
    }

    // Status config
    const statusConfig = byStatus({
        active: () => ({ label: 'Активно', bg: 'bg-emerald-500', dot: 'bg-emerald-400' }),
        inactive: () => ({ label: 'Неактивно', bg: 'bg-amber-500', dot: 'bg-amber-400' }),
        moderation: () => ({ label: 'На модерации', bg: 'bg-blue-500', dot: 'bg-blue-400' }),
        disabled: () => ({ label: 'Отключено', bg: 'bg-rose-500', dot: 'bg-rose-400' }),
        orElse: () => ({ label: 'Неизвестно', bg: 'bg-slate-500', dot: 'bg-slate-400' }),
    });

    // Color options for "colored" plan
    const colorOptions = [
        { value: "#fcc7c7", label: "Розовый" },
        { value: "#d8c7fc", label: "Фиолетовый" },
        { value: "#c7fcd6", label: "Зелёный" },
        { value: "#b8dcff", label: "Голубой" },
        { value: "#f7ffbf", label: "Жёлтый" },
        { value: "#e8e8e8", label: "Серый" },
    ];

    return (
        <>
            {/* Toast */}
            {toast.visible && (
                <div className="fixed top-4 left-4 right-4 sm:left-auto sm:right-6 sm:top-6 z-[9999] animate-fade-in-up">
                    <div className={`flex items-center gap-2 px-4 py-2.5 rounded-xl shadow-xl border text-sm font-medium backdrop-blur-sm ${
                        toast.type === 'success' ? 'bg-emerald-50/95 border-emerald-200 text-emerald-700'
                            : toast.type === 'warning' ? 'bg-amber-50/95 border-amber-200 text-amber-700'
                            : 'bg-rose-50/95 border-rose-200 text-rose-700'
                    }`}>
                        {toast.message}
                    </div>
                </div>
            )}

            {/* Card — stacks vertically on mobile, horizontal on tablet+ */}
            <div className="relative bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden flex flex-col sm:flex-row transition-all duration-200 hover:shadow-md">
                {/* Product Preview */}
                <div className="w-full sm:w-[45%] overflow-hidden flex-shrink-0">
                    <ProductItem
                        product={product}
                        border={false}
                    />
                </div>

                {/* Actions Panel */}
                <div className="w-full sm:w-[55%] p-3 sm:p-4 flex flex-col">
                    {/* Status Badge */}
                    <div className={classNames(
                        "inline-flex items-center gap-1.5 self-start px-3 py-1.5 rounded-lg text-white text-xs font-semibold mb-3",
                        statusConfig.bg
                    )}>
                        <span className={`w-1.5 h-1.5 rounded-full ${statusConfig.dot} animate-pulse`} />
                        {statusConfig.label}
                    </div>

                    {/* Action Buttons */}
                    <div className="flex flex-col gap-1.5 flex-1">
                        {/* Edit */}
                        <button
                            className="flex items-center gap-2.5 px-3 py-2 rounded-xl hover:bg-slate-50 active:bg-slate-100 transition-colors text-left"
                            onClick={() => history(`/products/${product.id}/edit`)}
                        >
                            <img src={editCircle} className="w-6 h-6 flex-shrink-0" alt="" />
                            <span className="text-sm font-medium text-slate-700">Редактировать</span>
                        </button>

                        {/* Subscription Plans (active only) */}
                        {byStatus({
                            active: () => (
                                subPlans?.map((item, idx) => (
                                    <button
                                        key={idx}
                                        className="flex items-center gap-2.5 px-3 py-2 rounded-xl hover:bg-slate-50 active:bg-slate-100 transition-colors text-left"
                                        onClick={() => makeSubscriptionModal(product.id, item.name)}
                                    >
                                        <img src={item.image} className="w-6 h-6 flex-shrink-0" alt="" />
                                        <span className="text-sm font-medium text-slate-700">{item.title}</span>
                                    </button>
                                ))
                            )
                        })}

                        {/* Activate/Deactivate */}
                        {byStatus({
                            active: () => (
                                <button
                                    className="flex items-center gap-2.5 px-3 py-2 rounded-xl hover:bg-amber-50 active:bg-amber-100 transition-colors text-left"
                                    onClick={deactivateAd}
                                >
                                    <svg className="w-6 h-6 text-amber-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                                    </svg>
                                    <span className="text-sm font-medium text-amber-700">Деактивировать</span>
                                </button>
                            ),
                            inactive: () => (
                                <button
                                    className="flex items-center gap-2.5 px-3 py-2 rounded-xl hover:bg-emerald-50 active:bg-emerald-100 transition-colors text-left"
                                    onClick={activateAd}
                                >
                                    <svg className="w-6 h-6 text-emerald-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <span className="text-sm font-medium text-emerald-700">Активировать</span>
                                </button>
                            )
                        })}

                        {/* Delete */}
                        <button
                            className="flex items-center gap-2.5 px-3 py-2 rounded-xl hover:bg-rose-50 active:bg-rose-100 transition-colors text-left"
                            onClick={removeAd}
                        >
                            <img src={deleteCircle} className="w-6 h-6 flex-shrink-0" alt="" />
                            <span className="text-sm font-medium text-rose-600">Удалить</span>
                        </button>
                    </div>
                </div>
            </div>

            {/* Subscription Plan Modal — replaces Ant Design Modal */}
            {isModalVisible && plan && (
                <div className="fixed inset-0 z-[9999] flex items-end sm:items-center justify-center">
                    <div
                        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
                        onClick={handleCancel}
                        style={{ animation: 'fadeIn 0.2s ease' }}
                    />
                    <div
                        className="relative w-full sm:max-w-md mx-auto bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl max-h-[85vh] overflow-y-auto"
                        style={{ animation: 'slideUp 0.3s ease' }}
                    >
                        {/* Drag Handle (mobile) */}
                        <div className="sm:hidden flex justify-center pt-3">
                            <div className="w-10 h-1 bg-slate-200 rounded-full" />
                        </div>

                        {/* Header */}
                        <div className="sticky top-0 bg-white/95 backdrop-blur-md px-5 py-4 border-b border-slate-100 flex items-center justify-between z-10">
                            <div className="flex items-center gap-3">
                                {plan.image && <img src={plan.image} className="w-8 h-8 rounded-lg" alt="" />}
                                <h3 className="text-lg font-bold text-slate-800">{plan.title}</h3>
                            </div>
                            <button
                                onClick={handleCancel}
                                className="w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition-colors"
                            >
                                <svg className="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        {/* Body */}
                        <div className="px-5 pb-6 pt-4 space-y-4">
                            <p className="text-sm text-slate-600">{plan.description}</p>

                            <div className="bg-slate-50 rounded-xl p-3 space-y-1">
                                {interval && (
                                    <div className="flex justify-between text-sm">
                                        <span className="text-slate-500">Промежуток</span>
                                        <span className="font-medium text-slate-700">{interval}</span>
                                    </div>
                                )}
                                <div className="flex justify-between text-sm">
                                    <span className="text-slate-500">Ваш баланс</span>
                                    <span className="font-bold text-slate-800">{user?.balance} сом</span>
                                </div>
                            </div>

                            {/* Period Selection with radio buttons OR range slider */}
                            {plan.periods?.length > 0 ? (
                                <div className="space-y-2">
                                    <h4 className="text-sm font-semibold text-slate-700">Выберите период:</h4>
                                    <div className="space-y-2">
                                        {plan.periods.map((item) => (
                                            <label
                                                key={item.id}
                                                className={classNames(
                                                    "flex items-center justify-between p-3 rounded-xl border-2 cursor-pointer transition-all duration-200",
                                                    periodId === item.id
                                                        ? "border-blue-500 bg-blue-50"
                                                        : "border-slate-200 hover:border-slate-300"
                                                )}
                                            >
                                                <div className="flex items-center gap-3">
                                                    <input
                                                        type="radio"
                                                        value={item.id}
                                                        checked={periodId === item.id}
                                                        onChange={() => {
                                                            setPeriodId(item.id);
                                                            setItemPrice(item.price);
                                                        }}
                                                        name="period"
                                                        className="w-4 h-4 text-blue-600"
                                                    />
                                                    <span className="text-sm font-medium text-slate-700">
                                                        {item.period} {interval}
                                                    </span>
                                                </div>
                                                <span className="text-sm font-bold text-blue-600">{item.price} {plan.currency}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {/* Color selection for "colored" plan */}
                                    {plan.name === "colored" && (
                                        <div className="space-y-2">
                                            <h4 className="text-sm font-semibold text-slate-700">Выберите цвет:</h4>
                                            <div className="grid grid-cols-3 gap-2">
                                                {colorOptions.map((opt) => (
                                                    <button
                                                        key={opt.value}
                                                        onClick={() => setColor(opt.value)}
                                                        className={classNames(
                                                            "flex items-center gap-2 px-3 py-2.5 rounded-xl border-2 transition-all duration-200 text-left",
                                                            color === opt.value
                                                                ? "border-blue-500 shadow-sm"
                                                                : "border-slate-200 hover:border-slate-300"
                                                        )}
                                                    >
                                                        <div
                                                            className="w-5 h-5 rounded-full flex-shrink-0 border border-slate-200"
                                                            style={{ backgroundColor: opt.value }}
                                                        />
                                                        <span className="text-xs font-medium text-slate-600">{opt.label}</span>
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Range slider for period */}
                                    <div className="space-y-2">
                                        <h4 className="text-sm font-semibold text-slate-700">Период действия:</h4>
                                        <div className="bg-slate-50 rounded-xl p-4">
                                            <div className="text-center mb-3">
                                                <span className="text-2xl font-bold text-blue-600">{plan.price * period}</span>
                                                <span className="text-sm text-slate-500 ml-1">{plan.currency}</span>
                                            </div>
                                            <input
                                                defaultValue={1}
                                                type="range"
                                                min="1"
                                                max="30"
                                                className="w-full accent-blue-500"
                                                onChange={(e) => {
                                                    setPeriod(e.target.value);
                                                    setItemPrice(plan.price * e.target.value);
                                                }}
                                            />
                                            <div className="text-center mt-1 text-sm text-slate-500">
                                                {period} {interval || ''}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Action Button */}
                            <button
                                onClick={() => plan.periods?.length > 0
                                    ? buyServiceBySelectedPeriod(user?.balance)
                                    : buyService(user?.balance, plan.name)
                                }
                                className="w-full py-3.5 bg-gradient-to-r from-blue-600 to-blue-500 text-white font-semibold text-sm rounded-xl shadow-lg shadow-blue-500/25 hover:from-blue-700 hover:to-blue-600 transition-all duration-200 active:scale-[0.98]"
                            >
                                Подключить услугу
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default UserProductItem;